const config = {
  "buildEnv": "production.min",
  "locations": {
    "port": {
      "SOP": "Southampton",
      "DOV": "Dover"
    },
    "carParking": {
      "ABZ": "Aberdeen",
      "BHD": "Belfast City (George Best)",
      "BFS": "Belfast International",
      "BHX": "Birmingham",
      "BOH": "Bournemouth",
      "BRS": "Bristol",
      "CWL": "Cardiff",
      "DSA": "Doncaster-Sheffield (Robin Hood)",
      "DUB": "Dublin",
      "MME": "Durham Tees Valley",
      "EMA": "East Midlands",
      "EDI": "Edinburgh",
      "EXT": "Exeter",
      "LGW": "Gatwick",
      "GLA": "Glasgow International",
      "PIK": "Glasgow Prestwick",
      "LHR": "Heathrow",
      "HUY": "Humberside ",
      "INV": "Inverness",
      "LBA": "Leeds Bradford",
      "LPL": "Liverpool",
      "LCY": "London City",
      "LTN": "Luton",
      "MAN": "Manchester",
      "NCL": "Newcastle",
      "NWI": "Norwich",
      "SNN": "Shannon",
      "SOU": "Southampton",
      "SEN": "Southend",
      "STN": "Stansted"
    },
    "hotels": {
      "ABZ": "Aberdeen",
      "BHD": "Belfast City (George Best)",
      "BHX": "Birmingham",
      "BOH": "Bournemouth",
      "BRS": "Bristol",
      "CWL": "Cardiff",
      "DSA": "Doncaster-Sheffield (Robin Hood)",
      "DUB": "Dublin",
      "MME": "Durham Tees Valley",
      "EMA": "East Midlands",
      "EDI": "Edinburgh",
      "EXT": "Exeter",
      "LGW": "Gatwick",
      "GLA": "Glasgow International",
      "PIK": "Glasgow Prestwick",
      "LHR": "Heathrow",
      "HUY": "Humberside",
      "LBA": "Leeds Bradford",
      "LPL": "Liverpool",
      "LCY": "London City",
      "LTN": "Luton",
      "MAN": "Manchester",
      "NCL": "Newcastle",
      "NWI": "Norwich",
      "SOU": "Southampton",
      "SEN": "Southend",
      "STN": "Stansted"
    },
    "lounges": {
      "OptGroupAirport": {
        "ABZ": "Aberdeen",
        "BHD": "Belfast City (George Best)",
        "BLK": "Blackpool",
        "BHX": "Birmingham",
        "BRS": "Bristol",
        "DSA": "Doncaster-Sheffield",
        "DUB": "Dublin",
        "MME": "Durham Tees Valley",
        "EMA": "East Midlands",
        "EDI": "Edinburgh",
        "EXT": "Exeter",
        "LGW": "Gatwick",
        "GLA": "Glasgow International",
        "PIK": "Glasgow Prestwick",
        "LHR": "Heathrow",
        "HUY": "Humberside",
        "INV": "Inverness",
        "LBA": "Leeds Bradford",
        "LPL": "Liverpool",
        "LCY": "London City",
        "LTN": "Luton",
        "MAN": "Manchester",
        "NCL": "Newcastle",
        "NWI": "Norwich",
        "SOU": "Southampton",
        "SEN": "Southend",
        "STN": "Stansted"
      },
      "OptGroupEurope": {
        "ALI": "Alicante",
        "AMT": "Amsterdam",
        "ATH": "Athens",
        "BCA": "Barcelona",
        "BAS": "Basel Switzerland",
        "BSG": "Berlin Schonefeld",
        "BLO": "Bologna",
        "BRL": "Brussels ",
        "BUU": "Budapest",
        "BUL": "Bulgaria Varna",
        "CGL": "Cologne",
        "CPH": "Copenhagen",
        "DLM": "Dalaman",
        "DUT": "Dusseldorf",
        "FAR": "Faro",
        "FRK": "Frankfurt",
        "FNC": "Funchal Madeira",
        "GVL": "Geneva",
        "GBR": "Gibraltar",
        "LPA": "Gran Canaria",
        "HBG": "Hamburg",
        "HER": "Heraklion",
        "KRA": "Krakow",
        "LZA": "Lanzarote",
        "LCA": "Larnaca",
        "LIP": "Leipzig Halle",
        "LIB": "Lisbon",
        "MAE": "Madrid",
        "AGQ": "Malaga",
        "MLA": "Malta",
        "MUN": "Munich",
        "NCI": "Nice",
        "PMQ": "Palma De Mallorca",
        "PFO": "Paphos",
        "OLY": "Paris (Orly)",
        "PDG": "Paris (Charles Ge Gaulle)",
        "PRA": "Prague",
        "FCQ": "Rome Fiumicino",
        "SCN": "Saarbrucken",
        "EST": "Tallinn",
        "TFN": "Tenerife",
        "TRU": "Turin",
        "VLA": "Valencia",
        "ZRL": "Zurich Switzerland"
      },
      "OptGroupWorldwide": {
        "AUH": "Abu Dhabi",
        "AGA": "Agadir",
        "ESB": "Ankara",
        "BAJ": "Bali",
        "BKK": "Bangkok",
        "BGI": "Barbados",
        "BJV": "Bodrum",
        "CUN": "Cancun",
        "CPT": "Capetown",
        "CNX": "Chiang Mai",
        "PUJ": "Dominican Republic Punta Cana ",
        "DXB": "Dubai",
        "GAM": "Gambia Banjul International ",
        "SGN": "Ho Chi Minh City",
        "HKG": "Hong Kong",
        "IST": "Istanbul",
        "ICA": "Tangier",
        "IAD": "Izmir",
        "CGK": "Jakarta",
        "BKI": "Kota Kinabalu",
        "KUL": "Kuala Lumpur",
        "MLE": "Maldives",
        "RAK": "Marrakech",
        "MBJ": "Montego Bay",
        "MCT": "Muscat",
        "DEL": "New Delhi",
        "AKL": "New Zealand",
        "SFB": "Orlando Sanford",
        "PEN": "Penang",
        "HKT": "Phuket",
        "POP": "Puerto Plata Airport",
        "JHB": "Senai",
        "PVG": "Shanghai Pudong",
        "SIN": "Singapore",
        "TLV": "Tel Aviv",
        "YTZ": "Toronto",
        "YVR": "Vancouver"
      }
    },
    "loungeCodes": {
      "ABZ": "Aberdeen",
      "BLK": "Blackpool",
      "BHX": "Birmingham",
      "BRS": "Bristol",
      "MME": "Durham Tees Valley",
      "EMA": "East Midlands",
      "EDI": "Edinburgh",
      "EXT": "Exeter",
      "LGW": "Gatwick",
      "GLA": "Glasgow International",
      "INV": "Inverness",
      "LHR": "Heathrow",
      "HUY": "Humberside",
      "LBA": "Leeds Bradford",
      "LPL": "Liverpool",
      "LTN": "Luton",
      "MAN": "Manchester",
      "NCL": "Newcastle",
      "SEN": "Southend",
      "STN": "Stansted"
    },
    "fastTrack": {
      "ABZ": "Aberdeen",
      "BOH": "Bournemouth",
      "BRS": "Bristol",
      "EDI": "Edinburgh",
      "EMA": "East Midlands",
      "LPL": "Liverpool",
      "LBA": "Leeds Bradford",
      "LTN": "Luton",
      "MAN": "Manchester",
      "NCL": "Newcastle",
      "STN": "Stansted"
    },
    "terminals": {
      "LHR": {
        "Terminal 2": "2",
        "Terminal 3": "3",
        "Terminal 4": "4",
        "Terminal 5": "5"
      },
      "LGW": {
        "North": "N",
        "South": "S"
      },
      "MAN": {
        "Terminal 1": "1",
        "Terminal 2": "2",
        "Terminal 3": "3"
      }
    },
    "altLocationNames": {
      "GLA": "Glasgow",
      "PIK": "Glasgow",
      "DSA": "Doncaster"
    },
    "locationRedirects": {
      "BFS": {
        "cp": "/belfast-international-airport.html"
      }
    }
  },
  "RoomTypes": {
    "D20": "Double - 2 adults",
    "T20": "Twin - 2 adults",
    "T11": "Twin - 1 adult 1 child",
    "S10": "Single - 1 adult",
    "T12": "Triple - 1 adult 2 children",
    "T21": "Triple - 2 adults 1 child",
    "T30": "Triple - 3 adults",
    "F13": "Family - 1 adult 3 children",
    "F22": "Family - 2 adults 2 children",
    "F23": "Family - 2 adults 3 children",
    "F31": "Family - 3 adults 1 child",
    "F32": "Family - 3 adults 2 children"
  },
  "sortOptions": {
    "carParking": {
      "": "Recommended",
      "price": "Price",
      "distance": "Distance"
    },
    "hotels": {
      "": "Recommended",
      "price": "Price",
      "distance": "Distance",
      "star_rating": "Star Rating"
    },
    "lounges": {
      "": "Recommended",
      "price": "Price"
    }
  },
  "appSettings": {
    "get_app_url": "https://hx.app.link/UNEASZrzQQ",
    "track_name": "app_link_clicked"
  },
  "domainSettings": {
    "language": "UK",
    "scheme": "https",
    "domainScheme": "https",
    "domain": "www.holidayextras.co.uk",
    "siteCode": "HXSEO-LIVE",
    "agentDomain": "www.holidayextras.co.uk",
    "assets": "https://staticsg.holidayextras.com",
    "assetsLocal": "",
    "assetsLive": "https://staticsg.holidayextras.com",
    "contentStaticServer": "https://static1.holidayextras.com",
    "assetVersion": 1554308593460,
    "trackerPath": "/hx-tracker/tracker.min.js"
  },
  "reviews": {
    "defaultLimit": 5,
    "defaultMaxLength": 500,
    "defaultStartDate": "-730"
  },
  "hotelFacilities": [
    {
      "key": "star_rating",
      "type": "stars",
      "label": "Star rating",
      "schema": false
    },
    {
      "key": "address",
      "type": "html",
      "label": "Address",
      "schema": false
    },
    {
      "key": "breakfast",
      "type": "html",
      "label": "Breakfast",
      "schema": true
    },
    {
      "key": "breakfast_times",
      "type": "html",
      "label": "Breakfast times",
      "schema": true
    },
    {
      "key": "breakfast_price",
      "type": "html",
      "label": "Breakfast price",
      "schema": true
    },
    {
      "key": "disabled_facilities",
      "type": "html",
      "label": "Disabled facilities",
      "schema": true
    },
    {
      "key": "q_internet",
      "type": "yn",
      "label": "Internet",
      "schema": true
    },
    {
      "key": "wifi",
      "type": "yn",
      "label": "Wi-Fi",
      "schema": true
    },
    {
      "key": "q_restaurant",
      "type": "yn",
      "label": "Restaurant",
      "schema": true
    },
    {
      "key": "q_roomservice",
      "type": "yn",
      "label": "Room service",
      "schema": true
    },
    {
      "key": "q_swimming",
      "type": "yn",
      "label": "Swimming pool",
      "schema": true
    },
    {
      "key": "all_rooms_non_smoking",
      "type": "yn",
      "label": "All rooms non-smoking",
      "schema": true
    },
    {
      "key": "ensuite",
      "type": "yn",
      "label": "En-suite bathroom",
      "schema": true
    },
    {
      "key": "hairdyer",
      "type": "yn",
      "label": "Hairdryer",
      "schema": true
    },
    {
      "key": "iron",
      "type": "yn",
      "label": "Iron",
      "schema": true
    },
    {
      "key": "trouser_press",
      "type": "yn",
      "label": "Trouser press",
      "schema": true
    },
    {
      "key": "kettle",
      "type": "yn",
      "label": "Kettle",
      "schema": true
    },
    {
      "key": "radio",
      "type": "yn",
      "label": "Radio",
      "schema": true
    },
    {
      "key": "room_phone",
      "type": "yn",
      "label": "Phone in room",
      "schema": true
    },
    {
      "key": "tv",
      "type": "yn",
      "label": "TV",
      "schema": true
    },
    {
      "key": "satellite",
      "type": "yn",
      "label": "Satellite TV",
      "schema": true
    }
  ],
  "settings": {
    "variationCookie": "variation",
    "priceFormat": "£",
    "decimalNotation": ".",
    "brand": "",
    "cookieExpiryDays": 30,
    "cookieDomain": ".holidayextras.co.uk",
    "soapiBase": "//static1.holidayextras.com/datafeeds/soapi/",
    "harpMessageRoute": "prodlib-multi?product=ADMalert&archived=1&noCache=1",
    "locationsRoute": "location",
    "locationReviewsRoute": "reviews",
    "locationPricesRoute": "prices",
    "retailTokenRoute": "agentRetailToken",
    "locationTableRoute": "location?prodlibSpecific=latitude,longitude,on_airport,distance_miles,transfer_time,transfer_minutes,transfers_included_in_price,free_transfers,transfer_price,meet_and_greet,name,address,wistia_key,star_rating,openingtime,closingtime,terminal,_prodcode,tripappimages,logo,prodlogo,brand_image,seo_optimised_brand_image_300_200,exclude_from_seo_table,adresse,parkplatzname",
    "bingSearchRoute": "bing-search",
    "customerRelationsEmail": "hasslefree@holidayextras.com",
    "pluginsExportDir": "../config/exports",
    "videoDataExportDir": "../config/exports/buildTimeOnly/videoData",
    "destinationLookup": "https://api.holidayextras.co.uk/destination.js",
    "docsAPIEndpoint": "https://static1.holidayextras.com/datafeeds/soapi/hapi-lookup?hapiRoute=info/docs/html&agent=WEB1",
    "docsAPIEndpointJSON": "https://static1.holidayextras.com/datafeeds/soapi/hapi-lookup?hapiRoute=info/docs&agent=WEB1",
    "agentLoginPage": "/login.php",
    "termsParam": "terms_and_conditions",
    "freeIfParam": "freeif",
    "operatingTimes": {
      "weekdayOpeningTime": "8pm",
      "weekdayClosingTime": "11pm",
      "weekendOpeningTime": "8:30am",
      "weekendClosingTime": "8pm"
    },
    "env": "production"
  },
  "agents": {
    "main": "WEB1",
    "search": "WY992",
    "responsys": "WO298",
    "discount": "WC125",
    "switchboardNumber": "0871 360 2603",
    "switchboardInsuranceNumber": "0800 316 0104",
    "switchboardMedicalInsuranceNumber": "0800 3160 308",
    "fallBackPhoneNumber": "0871 360 2603",
    "fallBackInsurancePhoneNumber": "01303 816144",
    "defaultPhoneNumbers": {
      "WY992": "0871 360 2603"
    },
    "noBookingFeesAgents": [
      "WY992"
    ]
  },
  "gtmTag": {
    "id": "GTM-N7ZF7K"
  },
  "formSettings": {
    "System": "",
    "language": "en",
    "dateFormat": "DD/MM/YY",
    "carHireAction": "//www.rentalcars.com/LoadingSearchResults.do",
    "carHireActionIntermediary": "//trip.holidayextras.co.uk/carHire/c/availability",
    "carHireLocationLookup": "//v2.holidayextras.co.uk/search/api/car-hire-location",
    "parkingAction": "//trip.holidayextras.co.uk/parking2008/c/availabilityV5",
    "hotelAction": "//trip.holidayextras.co.uk/hotels2008/c/availabilityV5",
    "loungeAction": "//trip.holidayextras.co.uk/lounges2008/c/availability",
    "fastTrackAction": "//trip.holidayextras.co.uk/fastTrack2008/c/availabilityV5",
    "cardAction": "//trip.holidayextras.co.uk/standaloneCurrencyCard/c/availability",
    "insuranceAction": "/travel-insurance/additional-information.html",
    "defaultParkingLocation": "LGW",
    "defaultHotelLocation": "LGW",
    "defaultLoungeLocation": "LGW",
    "defaultPortLocation": "DOV",
    "defaultFastTrackLocation": "MAN",
    "defaultRoomType": "D20",
    "defaultArrivalTime": "1200",
    "defaultDepartTime": "1300",
    "cookieKey": "chosenEngine",
    "method": "get",
    "ruleset": "hx",
    "carHireLocationSearch": "https://www.rentalcars.com/FTSAutocomplete.do",
    "flightSearch": "https://flight.dock-yard.io/",
    "imageCloudEndpoint": "https://image-cloud.dock-yard.io/fetch",
    "imageCloudEndpointImage": "https://image-cloud.dock-yard.io/image",
    "imageCloudCDN": "https://dmy0b9oeprz0f.cloudfront.net",
    "imageCloudWebsite": "holidayextras.co.uk",
    "parkingFilters": [
      {
        "name": "filter_meetandgreet",
        "text": "Meet & Greet"
      },
      {
        "name": "filter_parkandride",
        "text": "Park & Ride"
      }
    ],
    "vacSettings": {
      "viewAmendCancelEndpoints": {
        "path": "https://secure.holidayextras.co.uk/managemybooking/c/",
        "insurancePath": "https://secure.holidayextras.co.uk/insurancemagenta/m/viewPolicy",
        "helpPath": "https://help.holidayextras.co.uk/hc/en-gb"
      },
      "pages": {
        "amendBooking": "amend",
        "viewBooking": "view",
        "cancelBooking": "cancel",
        "addUpgrades": "upgrade",
        "resendConfirmation": ""
      },
      "requiredParams": {
        "product": "gen",
        "request": "7"
      }
    },
    "engineOptions": {
      "ho": {
        "canSellFlag": "HotelBookings",
        "productClass": "ho",
        "product": "ho",
        "text": "Airport <br>Hotels",
        "homepageText": "Airport <br>Hotels",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'><path class='cls-1' d='M43.16,13.62a9.92,9.92,0,1,1,0,19.84H15.44a9.92,9.92,0,0,1,0-19.84'/><path class='cls-1' d='M16.19,13.73A10.84,10.84,0,1,1,37,17.95'/><polyline class='cls-1' points='74 35 74 42 78 42'/><polyline class='cls-1' points='74 53 74 60 78 60'/><polyline class='cls-1' points='40.76 41.01 40.76 125.11 87.28 125.11 87.28 22.41 60.3 22.41'/><path class='cls-1' d='M76.45,105.66a12.23,12.23,0,0,0-24.46,0Z'/><line class='cls-1' x1='70' y1='124' x2='70' y2='106'/><line class='cls-1' x1='57' y1='106' x2='57' y2='124'/><polyline class='cls-1' points='62 35 62 42 65 42'/><polyline class='cls-1' points='50 53 50 60 53 60'/><polyline class='cls-1' points='62 53 62 60 65 60'/><polyline class='cls-1' points='74 74 74 81 78 81'/><polyline class='cls-1' points='50 74 50 81 53 81'/><polyline class='cls-1' points='62 74 62 81 65 81'/><polyline class='cls-1' points='40.21 79.95 2.44 87.92 2.44 78.31 40.21 55.19'/><polyline class='cls-1' points='87.79 79.95 125.56 87.92 125.56 78.31 87.79 55.19'/><line class='cls-1' x1='20' y1='125' x2='107' y2='125'/><path class='cls-1' d='M81.15,21.69a18.22,18.22,0,0,0-34.51-8.17'/></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/ho/airport-hotels.jpg",
          "alt": "Airport hotels"
        }
      },
      "hcp": {
        "canSellFlag": "HotelParking",
        "productClass": "hcp",
        "product": "hcp",
        "text": "<span class='hidden-sm hidden-md locationTag'>Airport </span>Hotel <br>& Parking",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'><path class='cls-1' d='M53.5,111.38h-4.6a1.93,1.93,0,0,1-1.73-1.08l-1.65-3.36a1.93,1.93,0,0,1-.2-.85V96.5a1.93,1.93,0,0,1,.13-.69L50.9,81.57a1.93,1.93,0,0,1,1.8-1.24H91.77a1.93,1.93,0,0,1,1.66.95l7.93,13.4a1.93,1.93,0,0,0,1.66.95h18.26a1.93,1.93,0,0,1,1.3.5l2.31,3.53,0,7.85a1.93,1.93,0,0,1-1.8,1.27h0'/><line class='cls-1' x1='74.35' y1='112.29' x2='102.89' y2='112.29'/><circle class='cls-1' cx='63.99' cy='114.39' r='10.07'/><circle class='cls-1' cx='112.96' cy='114.39' r='10.07'/><line class='cls-1' x1='92' y1='95' x2='53' y2='95'/><line class='cls-1' x1='79' y1='95' x2='79' y2='83'/><polyline class='cls-1' points='46.55 119.01 5.03 119.01 5.03 14.23 70.32 14.23 70.32 72.24'/><polyline class='cls-1' points='59 65 59 55 53 55'/><polyline class='cls-1' points='40 65 40 55 34 55'/><polyline class='cls-1' points='22 65 22 55 15 55'/><polyline class='cls-1' points='59 39 59 29 53 29'/><polyline class='cls-1' points='40 39 40 29 34 29'/><polyline class='cls-1' points='22 39 22 29 15 29'/><polyline class='cls-1' points='69.88 14.23 71.75 4 2.78 4 4.72 13.76'/><polyline class='cls-1' points='40 90 40 80 34 80'/><polyline class='cls-1' points='24 90 24 80 16 80'/><rect class='cls-1' x='81.5' y='23.6' width='37.26' height='38.82'/><line class='cls-1' x1='79' y1='34' x2='72' y2='34'/><line class='cls-1' x1='79' y1='55' x2='72' y2='55'/><path class='cls-1' d='M95.5,51.28v-16h4.81a4.81,4.81,0,0,1,0,9.61H96.71'/></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/hcp/airport-hotel-and-parking.jpg",
          "alt": "Airport hotel & parking"
        }
      },
      "cp": {
        "canSellFlag": "CarParkBookings",
        "productClass": "cp",
        "product": "cp",
        "text": "Airport <br>Parking",
        "homepageText": "Airport <br>Parking",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'><polyline class='cls-1' points='11.46 83.01 2.4 47 11.88 47 37.24 76.42'/><rect class='cls-1' x='48.26' y='87.79' width='7.03' height='9.68' rx='3.52' ry='3.52' transform='translate(103.56 185.27) rotate(180)'/><rect class='cls-1' x='33.73' y='87.79' width='7.03' height='9.68' rx='3.52' ry='3.52' transform='translate(74.49 185.27) rotate(180)'/><path class='cls-1' d='M58,109.65c-39.69,0-53-12-53-12v-10s13.34-12,53-12'/><rect class='cls-1' x='41.33' y='7.53' width='45.75' height='45.75' rx='12' ry='12' transform='translate(131.11 6.52) rotate(135)'/><path class='cls-1' d='M58,33.88H65.7a7.4,7.4,0,1,0,0-14.79H58v23.8'/><line class='cls-1' x1='64' y1='60' x2='64' y2='124'/><path class='cls-1' d='M113.36,109.48h9a3.52,3.52,0,0,0,3.52-3.52v-5.72a3.52,3.52,0,0,0-1.11-2.57L122,95.16a2,2,0,0,0-1.31-.5L102.27,90.8a2,2,0,0,1-1.68-1L86.41,76.3a2,2,0,0,0-1.68-1H70'/><circle class='cls-1' cx='103.17' cy='109.78' r='10.18'/><line class='cls-1' x1='70' y1='110' x2='93' y2='110'/><line class='cls-1' x1='4' y1='125' x2='125' y2='125'/><line class='cls-1' x1='102' y1='91' x2='85' y2='91'/></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/cp/airport-parking.jpg",
          "alt": "Airport parking"
        }
      },
      "otherProducts": {
        "productClass": "otherProducts",
        "product": "otherProducts",
        "text": "Other<br class='visible-xs'>Extras",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128' class='svgfill'><g><path d='M89.62,101.19c-1.51,0-2.52-.05-2.8-.07L12,100.3a2,2,0,0,1-.8-3.82l28.58-12.9a2,2,0,0,1,1.64,3.65L21.08,96.4l65.83.72c.31,0,21.63,1.18,31.69-8.47a16.94,16.94,0,0,0,5.16-13.09v-.72c-.22-11.64-.58-31.13-8-40.95-2.86-3.77-6.71-5.52-8.5-4.79-1.55.63-2.17,3.53-1.64,7.75l1.6,17.33a2,2,0,0,1-4,.37l-1.59-17.26c-1-8,1.68-10.9,4.11-11.88,4.31-1.76,9.9,1.73,13.2,6.08,8.22,10.86,8.58,30.37,8.83,43.28v.72a20.79,20.79,0,0,1-6.4,16.06C112.29,100.24,96.17,101.19,89.62,101.19Z'/><path d='M24,58H2a2,2,0,0,1,0-4H24a2,2,0,0,1,0,4Z'/><path d='M28,69H14a2,2,0,0,1,0-4H28a2,2,0,0,1,0,4Z'/><path d='M34,46H13a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z'/><path d='M111.68,29.15a2,2,0,0,1-1.9-1.38L105,13.08a2,2,0,0,1,3.8-1.24l4.77,14.69a2,2,0,0,1-1.9,2.62Z'/><path d='M106.45,13.8a3.68,3.68,0,1,1,3.65-4.19h0a3.69,3.69,0,0,1-3.65,4.18Zm.33-3.72-.64.09a.31.31,0,0,0,.36.27.32.32,0,0,0,.27-.36Zm-.32-.28h0a.32.32,0,0,0-.27.36l.64-.09a.33.33,0,0,0-.12-.21A.33.33,0,0,0,106.45,9.8Z'/><path d='M102.83,30.92a2,2,0,0,1-1.79-1.1L92.74,13.36a2,2,0,0,1,3.57-1.8L104.62,28a2,2,0,0,1-1.78,2.9Z'/><path d='M93.17,14.68a3.68,3.68,0,1,1,3.65-4.19h0a3.68,3.68,0,0,1-3.14,4.15A3.78,3.78,0,0,1,93.17,14.68ZM92.86,11a.33.33,0,0,0,.13.21.31.31,0,0,0,.24.06.32.32,0,0,0,.27-.36.33.33,0,0,0-.12-.21.31.31,0,0,0-.24-.06.32.32,0,0,0-.21.12.33.33,0,0,0-.06.24Z'/><path d='M68.44,94.57A31.22,31.22,0,0,1,58,92.78a32.5,32.5,0,0,1-20-20.17A33.36,33.36,0,0,1,58.68,30.23,39.71,39.71,0,0,1,88,31.72a29.1,29.1,0,0,1,12.81,11.65,58,58,0,0,1,2.72,5.15c1.74,3.58,3.38,7,6.45,9.18a2,2,0,0,1,.79,1.26c.1.54,2.33,13.23-4.28,21.16-3.34,4-8.27,6-14.65,6a2,2,0,0,1-1.55-.73,26,26,0,0,1-5.34,4.38A31,31,0,0,1,68.44,94.57Zm2.91-62.42A34.92,34.92,0,0,0,60,34,29.35,29.35,0,0,0,41.85,71.3,28.52,28.52,0,0,0,59.37,89a27,27,0,0,0,23.44-2.59c7.82-4.89,9.24-11.42,9.05-16-.32-8-5.69-16.2-13.06-20A16.55,16.55,0,0,0,61.59,51a12.21,12.21,0,0,0,13.2,20.53A2,2,0,0,1,77,74.87,16.21,16.21,0,0,1,59.42,47.61a20.41,20.41,0,0,1,21.22-.8c8.58,4.46,14.84,14.09,15.21,23.42a20.68,20.68,0,0,1-3.08,11.91c4.66-.18,8.22-1.72,10.61-4.58,4.61-5.52,3.87-14.54,3.53-17.16-3.43-2.77-5.25-6.52-7-10.14a54.2,54.2,0,0,0-2.53-4.8A25.21,25.21,0,0,0,86.29,35.36,36,36,0,0,0,71.35,32.15Z'/><path d='M36.15,121.56A12.36,12.36,0,1,1,48.5,109.2,12.37,12.37,0,0,1,36.15,121.56Zm0-20.71a8.36,8.36,0,1,0,8.36,8.36A8.37,8.37,0,0,0,36.15,100.85Z'/><path d='M100.76,121.56a12.36,12.36,0,1,1,12.36-12.36A12.37,12.37,0,0,1,100.76,121.56Zm0-20.71a8.36,8.36,0,1,0,8.36,8.36A8.37,8.37,0,0,0,100.76,100.85Z'/><path d='M35.79,114.67a2,2,0,1,1,0-4,1.82,1.82,0,0,0,1.82-1.82,2,2,0,0,1,4,0A5.82,5.82,0,0,1,35.79,114.67Z'/><path d='M100.92,114.67a2,2,0,0,1,0-4,1.82,1.82,0,0,0,1.82-1.82,2,2,0,0,1,4,0A5.82,5.82,0,0,1,100.92,114.67Z'/></g></svg>"
      },
      "lo": {
        "canSellFlag": "LoungeBookings",
        "productClass": "lo",
        "product": "lo",
        "text": "Airport <br>Lounges",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128' class='svgfill'><g><path d='M69.68,116.42H7.49a5.66,5.66,0,0,1-5.66-5.66V79.52a5.66,5.66,0,0,1,5.66-5.66h7.06a5.66,5.66,0,0,1,5.66,5.66V93.06a2,2,0,0,1-4,0V79.52a1.66,1.66,0,0,0-1.66-1.66H7.49a1.66,1.66,0,0,0-1.66,1.66v31.24a1.66,1.66,0,0,0,1.66,1.66H69.68a1.66,1.66,0,0,0,1.66-1.66V79.52a1.66,1.66,0,0,0-1.66-1.66H62.89a1.66,1.66,0,0,0-1.66,1.66V92a2,2,0,0,1-4,0V79.52a5.66,5.66,0,0,1,5.66-5.66h6.79a5.66,5.66,0,0,1,5.66,5.66v31.24A5.66,5.66,0,0,1,69.68,116.42Z'/><path d='M54.38,102H23.1a6.86,6.86,0,0,1-6.85-6.85v-3a6.86,6.86,0,0,1,6.85-6.85H54.38a6.86,6.86,0,0,1,6.85,6.85v3A6.86,6.86,0,0,1,54.38,102ZM23.1,89.36a2.85,2.85,0,0,0-2.85,2.85v3A2.85,2.85,0,0,0,23.1,98H54.38a2.85,2.85,0,0,0,2.85-2.85v-3a2.85,2.85,0,0,0-2.85-2.85Z'/><path d='M116,124H78a2,2,0,0,1,0-4h38a2,2,0,0,1,0,4Z'/><path d='M98,107H90a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Z'/><path d='M97.48,82.45a2,2,0,0,1-.36-4L105.41,77a2,2,0,1,1,.72,3.94l-8.28,1.51A2.06,2.06,0,0,1,97.48,82.45Z'/><path d='M90.71,65.88A2,2,0,0,1,90,62l6.42-2.57a2,2,0,0,1,1.49,3.71l-6.42,2.57A2,2,0,0,1,90.71,65.88Z'/><path d='M119.26,19.84h-.1l-19.07-.9a2,2,0,0,1-1.61-1l-2.23-3.67-2.38,3.37a2,2,0,0,1-1.71.84l-19.53-.79a2,2,0,1,1,.16-4l18.44.75,3.51-5a2,2,0,0,1,1.7-.84,2,2,0,0,1,1.64,1L101.35,15l12.9.61c-5.57-5.13-13-9.39-25.61-10.06A55.91,55.91,0,0,0,60.07,11a2,2,0,1,1-1.71-3.62A60.53,60.53,0,0,1,88.84,1.55c16.89.89,25.31,7.71,31.9,14.95a2,2,0,0,1-1.48,3.35Z'/><path d='M51.74,64.33l-.27,0a2,2,0,0,1-1.7-1.64L47.32,48.6l0-.12c-1.75-15.79,3.36-25.88,3.58-26.3A2,2,0,0,1,54.44,24c0,.09-4.75,9.49-3.16,24l1.36,7.83,5.6-11.72-3.06-4.74A2,2,0,0,1,57,36.26l5.83.38,8-21.6a2,2,0,0,1,3.75,1.39L66,39.42a2,2,0,0,1-2,1.3l-3.36-.22,1.51,2.35a2,2,0,0,1,.12,1.94L53.54,63.2A2,2,0,0,1,51.74,64.33Z'/><path d='M4.89,43.65A2,2,0,0,1,3,41C6.33,31.83,14.1,19.45,32.24,12.4,41.45,8.82,50.87,7,58.73,7.33c8.42.33,14,3.05,15.84,7.68a2,2,0,0,1-1.17,2.6L53.35,25a2,2,0,0,1-1.76-.19l-4.94-3.12-1.28,5.47a2,2,0,0,1-1.64,1.52A95.66,95.66,0,0,0,6.07,43.27,2,2,0,0,1,4.89,43.65ZM57,11.29a66.39,66.39,0,0,0-23.29,4.84c-13,5.07-20.27,13.08-24.25,20.32A101.35,101.35,0,0,1,41.78,24.93L43.4,18a2,2,0,0,1,3-1.24l6.48,4.09,16.78-6.17c-2-2-5.87-3.19-11.1-3.39C58.05,11.3,57.52,11.29,57,11.29ZM43.43,26.69h0Z'/><path d='M60,122a2,2,0,0,1-2-2v-5a2,2,0,0,1,4,0v5A2,2,0,0,1,60,122Z'/><path d='M13,122a2,2,0,0,1-2-2v-5a2,2,0,0,1,4,0v5A2,2,0,0,1,13,122Z'/><path d='M86.11,122.1a2,2,0,0,1-2-2.44c2.08-9.29,5.47-27.6,4.72-45.88C88,51.18,81.19,35.49,68.76,27.13A2,2,0,1,1,71,23.81c13.55,9.1,20.91,25.86,21.89,49.81.76,18.74-2.69,37.44-4.81,46.92A2,2,0,0,1,86.11,122.1Z'/><path d='M105,122.1a2,2,0,0,1-2-2.37,159.38,159.38,0,0,0,1-48.37c-3.75-26-14.61-44.11-32.27-53.89A2,2,0,0,1,73.68,14C92.49,24.4,104,43.51,108,70.79a163.67,163.67,0,0,1-1,49.68A2,2,0,0,1,105,122.1Z'/><path d='M63.94,77.86a2,2,0,0,1-2-2V59.52a4.88,4.88,0,0,0-4.87-4.87,2,2,0,0,1,0-4,8.88,8.88,0,0,1,8.87,8.87V75.86A2,2,0,0,1,63.94,77.86Z'/><path d='M13.22,77.86a2,2,0,0,1-2-2V59.52a8.88,8.88,0,0,1,8.87-8.87h30a2,2,0,0,1,0,4h-30a4.88,4.88,0,0,0-4.87,4.87V75.86A2,2,0,0,1,13.22,77.86Z'/></g></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/lo/airport-lounges.jpg",
          "alt": "Airport lounges"
        }
      },
      "ins": {
        "canSellFlag": "InsuranceBookings",
        "productClass": "ins",
        "product": "ins",
        "text": "Holiday <br class='hidden-xs'>Insurance",
        "productText": "Award Winning Insurance Provider for your Trip",
        "link": "/holiday-insurance.html",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128' class='svgfill'><g><path d='M61.77,70.59a11.3,11.3,0,1,1,11.3-11.3A11.31,11.31,0,0,1,61.77,70.59Zm0-18.59a7.3,7.3,0,1,0,7.3,7.3A7.31,7.31,0,0,0,61.77,52Z'/><path d='M51,115.91a2,2,0,0,1-2-2V86.72a12.83,12.83,0,0,1,25-4.2,15.09,15.09,0,0,1,.94,4.78,2,2,0,0,1-4,0,11.31,11.31,0,0,0-.7-3.4A8.83,8.83,0,0,0,53,86.72v27.2A2,2,0,0,1,51,115.91Z'/><path d='M87.26,82a11.3,11.3,0,1,1,11.3-11.3A11.31,11.31,0,0,1,87.26,82Zm0-18.59a7.3,7.3,0,1,0,7.3,7.3A7.31,7.31,0,0,0,87.26,63.41Z'/><path d='M97.59,115.91h-.06a2,2,0,0,1-1.94-2.06L96.11,97a8.84,8.84,0,0,0-17.67.06l-.08,16.83a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2l.08-16.82a12.83,12.83,0,0,1,25.67,0L99.58,114A2,2,0,0,1,97.59,115.91Z'/><path d='M36.88,86.07A9,9,0,0,1,28,76,9,9,0,1,1,45.79,78.2h0A9,9,0,0,1,36.88,86.07Zm0-14a5,5,0,1,0,5,5.6h0a5,5,0,0,0-4.33-5.56A5,5,0,0,0,36.87,72.1ZM43.8,78h0Z'/><path d='M29.89,115.91h0a2,2,0,0,1-2-2l0-17.09a1.87,1.87,0,0,1,0-.25,9.63,9.63,0,0,1,18.82-1.42,2,2,0,0,1-3.85,1.1,5.63,5.63,0,0,0-4.72-4.06A5.65,5.65,0,0,0,31.92,97l0,17A2,2,0,0,1,29.89,115.91Z'/><path d='M9.75,36.88a2,2,0,0,1-1.59-3.21,64,64,0,0,1,29-21.46A2,2,0,0,1,38.5,16,60.06,60.06,0,0,0,11.35,36.08,2,2,0,0,1,9.75,36.88Z'/><path d='M119.72,100.16a2,2,0,0,1-1.87-2.71A57.55,57.55,0,1,0,9.08,94.36a2,2,0,0,1-3.82,1.2,61.55,61.55,0,1,1,116.33,3.31A2,2,0,0,1,119.72,100.16Z'/></g></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/ins/holiday-insurance.jpg",
          "alt": "Holiday insurance"
        }
      },
      "medical": {
        "canSellFlag": "InsuranceBookings",
        "productClass": "medical",
        "product": "medical",
        "text": "Medical Travel<br class='hidden-xs'> Insurance",
        "productText": "Specialists in pre-existing medical condition holiday insurance",
        "link": "/travel-insurance/medical-conditions.html",
        "svg": "<svg viewBox='0 0 129 129' xmlns='http://www.w3.org/2000/svg'><path class='st0' d='m81.78 37.38c-3.24-5.15-10.53-9.45-10.53-9.45m17 96.39c1.56-9.25 4.16-27.51 4.1-45.87-0.02-7.41-0.46-14.12-1.32-20.13m16.4 22.05l-9.48 2.02m-6.76-15.8l7.19-3.13m-6.71 42.8h7.31'/><path class='st0' d='M105.89 122.73c.78-4.07 4.47-25.55 1.04-48.98-3.94-26.9-15.48-45.74-34.29-56.01'/><path class='st0' d='M51.17 27.85c-.99 2.61-1.99 6.1-2.37 8.34-2.89 16.85 1.36 28.31 1.36 28.31l9.2-17.79-4.26-5.94h7.24l13.23-20.78'/><path class='st0' d='m33.15 17.07c-17.23 8.47-22.4 19.66-26.9 28.86 7.26-4.62 17.66-10.47 34.01-13.6 0 0 3.39-8.29 4.07-8.6s8.48 3.47 8.48 3.47l21.46-8.86c-2.24-2.51-23.9-9.74-41.12-1.27z'/><path class='st0' d='M57.08 12.44s10.5-8.48 31.46-7.45c20.77 1.02 31.66 14.99 31.66 14.99l-19.37-.74-4.1-5.03-4.07 4.84-20.02-1.31'/><path class='st0' d='m78.4 125.34h38.3'/><path class='st0' d='m88.01 34.86s-32.67 7.83-45.99 82.26l13.84-5.25 6.11 13.48c43.06-62.15 26.04-90.49 26.04-90.49z'/><path class='st1' d='m72.19 73.17l-4.99 12.09m-3.55-8.54l12.09 4.99'/></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/medical/12-medical-body.jpg",
          "alt": "Medical Insurance"
        }
      },
      "portparking": {
        "isHidden": true,
        "canSellFlag": "PortParking",
        "productClass": "portparking",
        "product": "portparking",
        "text": "Port <br> Parking",
        "productText": "Save on car parking at UK ports",
        "link": "/port-parking.html",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 129 129'><g><g><path d='M72.64 54.39l15.38-15.38c4.67-4.67 4.67-12.3 0-16.97L72.64 6.65c-4.67-4.67-12.3-4.67-16.97 0L40.29 22.04c-4.67 4.67-4.67 12.3 0 16.97l15.38 15.38c4.67 4.67 12.3 4.67 16.97 0z' fill-rule='evenodd' clip-rule='evenodd' fill='none' stroke='#000' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10'/><path class='st0' d='M58 33.99h7.66c4.08 0 7.4-3.31 7.4-7.4s-3.31-7.4-7.4-7.4H58V43M63.95 60.11v64M3.95 125.11h121'/></g><g><path class='st0' d='M113.31 109.59h8.96c1.94 0 3.52-1.58 3.52-3.52v-5.72c0-.97-.4-1.9-1.11-2.57L122 95.27c-.36-.32-.83-.5-1.31-.5l-18.46-3.85c-.69 0-1.33-.36-1.68-.96L86.37 76.41a1.96 1.96 0 0 0-1.68-.96H69.95'/><circle class='st0' cx='103.12' cy='109.89' r='10.18'/><path class='st0' d='M69.95 110.11h23M101.95 91.11h-17'/></g><g><circle class='st0' cx='111.28' cy='74.87' r='3.37'/><circle class='st0' cx='111.28' cy='52.73' r='5'/><circle class='st0' cx='111.28' cy='28.08' r='7'/></g><path class='st0' d='M58.01 75.83c-11.03.96-21.31 5.32-26.43 9.89-1.63-2.08-5.75-7.11-8.09-9.12-8.98-7.73-17.48-7.33-17.48-7.33l9.58 23.61-9.58 23.61s8.25.27 17.48-7.33c2.38-1.96 6.45-7.04 8.09-9.12 5.11 4.57 15.38 8.92 26.39 9.89'/></g></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/portparking/12-port-shark.jpg",
          "alt": "Port Parking"
        }
      },
      "porthotels": {
        "isHidden": true,
        "canSellFlag": "PortHotels",
        "productClass": "porthotels",
        "product": "porthotels",
        "text": "Port <br> Hotels",
        "productText": "Discounted stays at UK ports",
        "link": "/port-hotels.html",
        "svg": "<svg viewBox='0 0 129 129' xmlns='http://www.w3.org/2000/svg'><path class='st0' d='m74.95 35.29v7h4m-4 11v7h4'/><path class='st0' d='M41.71 22.71h46.53v102.7H41.71z'/><path class='st0' d='m77.4 105.96c0-6.75-5.47-12.23-12.23-12.23-6.75 0-12.23 5.47-12.23 12.23h24.46zm-6.45 18.33v-18m-13 0v18m5-89v7h3m-15 11v7h3m-3-25v7h3m9 11v7h3m9 14v7h4m-28-7v7h3m9-7v7h3m-45 44h87m-60.36-102.58c0-9.32 7.55-16.87 16.87-16.87s16.87 7.55 16.87 16.87'/><path class='st0' d='m22.91 78.18c-5.3 0-8.92 3.24-11.02 5.93l-8.41-5.42 3.32 8.92-3.32 8.92 8.37-5.4c2.09 2.7 5.72 5.99 11.06 5.99 10.14 0 13.24-9.47 13.24-9.47s-2.63-9.47-13.24-9.47z'/><circle class='st0' cx='28.73' cy='87.06' r='.72'/><circle class='st0' cx='26.6' cy='65.32' r='3'/><circle class='st0' cx='26.6' cy='43.4' r='4.5'/><circle class='st0' cx='26.6' cy='19.48' r='5.5'/><path class='st0' d='M103.3 34.13s-5.8 8.24-7.17 22.27c-1.23 12.6 1.07 21.05 6.1 32.34s4.73 16.47 2.44 24.56c-2.03 7.17-5.03 10.83-5.03 10.83s13.42-19.83 11.14-36c-2.29-16.17-9.46-26.39-8.85-37.53.56-10.2 1.37-16.47 1.37-16.47z'/><path class='st0' d='M114.13 43.13s-5.95 10.83-4.12 19.68 5.64 14.19 3.97 28.98c-1.69 14.88-12.51 30.2-12.51 30.2s5.57-7.27 15.25-26.85c7.17-14.49 1.53-28.98-.61-35.54-2.13-6.55-1.98-16.47-1.98-16.47z'/></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/porthotels/12-cabin-port.jpg",
          "alt": "Port Hotels"
        }
      },
      "carhire": {
        "canSellFlag": "CarHireBookings",
        "productClass": "carhire",
        "product": "carhire",
        "text": "Car <br class='hidden-xs'>Hire",
        "productText": "Award-winning car hire with FREE cancellation options",
        "link": "/car-hire.html?launch_id=ENG",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128' class='svgfill'><g><path d='M104.63,92.09H23.37c-10.26,0-14.61-1.82-14.68-13L5.33,67.72a2,2,0,0,1,.14-1.49l8.68-16.72a2,2,0,0,1,.47-.6L37.71,29.09a2,2,0,0,1,1.3-.48H86.39a2,2,0,0,1,1.28.46l24,19.82a2,2,0,0,1,.42.48l10.4,16.72a2,2,0,0,1,.22,1.63l-3.36,11.34C119.23,90.27,114.89,92.09,104.63,92.09ZM9.4,67.36,12.61,78.2a2,2,0,0,1,.08.57c0,8.57,1.75,9.32,10.68,9.32h81.25c9.38,0,10.68-1.13,10.68-9.32a2,2,0,0,1,.08-.57l3.19-10.75-9.76-15.68L85.67,32.61H39.76L17.53,51.7Z'/><path d='M103,58H24a2,2,0,0,1,0-4h79a2,2,0,0,1,0,4Z'/><path d='M82,86H47a2,2,0,0,1,0-4H82a2,2,0,0,1,0,4Z'/><path d='M82,77H47a2,2,0,0,1,0-4H82a2,2,0,0,1,0,4Z'/><path d='M37.13,82.69H22a2,2,0,0,1-2-2V72.2a2,2,0,0,1,2-2H37.13a2,2,0,0,1,2,2v8.48A2,2,0,0,1,37.13,82.69ZM24,78.69H35.13V74.2H24Z'/><path d='M106,82.69H90.87a2,2,0,0,1-2-2V72.2a2,2,0,0,1,2-2H106a2,2,0,0,1,2,2v8.48A2,2,0,0,1,106,82.69Zm-13.13-4H104V74.2H92.87Z'/><path d='M8,118a2,2,0,0,1-2-2V106a2,2,0,0,1,4,0v10A2,2,0,0,1,8,118Z'/><path d='M17,127a2,2,0,0,1-2-2V111a2,2,0,0,1,4,0v14A2,2,0,0,1,17,127Z'/><path d='M26,116a2,2,0,0,1-2-2v-8a2,2,0,0,1,4,0v8A2,2,0,0,1,26,116Z'/><path d='M98,118a2,2,0,0,1-2-2v-5a2,2,0,0,1,4,0v5A2,2,0,0,1,98,118Z'/><path d='M104,127a2,2,0,0,1-2-2V106a2,2,0,0,1,4,0v19A2,2,0,0,1,104,127Z'/><path d='M112,116a2,2,0,0,1-2-2v-5a2,2,0,0,1,4,0v5A2,2,0,0,1,112,116Z'/><path d='M119.24,99H96.07a6.27,6.27,0,0,1-6.26-6.26,2,2,0,0,1,4,0A2.26,2.26,0,0,0,96.07,95h23.17a2.26,2.26,0,0,0,2.26-2.26V87.88a2.26,2.26,0,0,0-2.26-2.26,2,2,0,1,1,0-4,6.27,6.27,0,0,1,6.26,6.26v4.87A6.27,6.27,0,0,1,119.24,99Z'/><path d='M31.93,99H8.76A6.27,6.27,0,0,1,2.5,92.75V87.88a6.27,6.27,0,0,1,6.26-6.26,2,2,0,1,1,0,4A2.26,2.26,0,0,0,6.5,87.88v4.87A2.26,2.26,0,0,0,8.76,95H31.93a2.26,2.26,0,0,0,2.26-2.26,2,2,0,0,1,4,0A6.27,6.27,0,0,1,31.93,99Z'/><path d='M45.79,32.38c-.6,0-1.19.23-1.59-.28L24.53,7H11.87l3.35,5H24a2,2,0,0,1,0,4H14.14c-.67,0-1.29-.83-1.66-1.39l-6-9.25a1.39,1.39,0,0,1-.1-1.68C6.7,3,7.38,3,8.12,3h17.4c.62,0,1.21-.21,1.59.28L47.38,29.41A1.85,1.85,0,0,1,47,32.09,1.88,1.88,0,0,1,45.79,32.38Z'/><path d='M79.48,32.38a2,2,0,0,1-1.58-3.23L98.45,3.27c.38-.49,1-.27,1.58-.27h17.4c.74,0,1.42-.09,1.76.56a1.58,1.58,0,0,1-.1,1.8l-6,9.38c-.37.55-1,1.26-1.66,1.26H101a2,2,0,0,1,0-4h9.33l3.35-5H101L81.06,32.11C80.66,32.61,80.07,32.38,79.48,32.38Z'/></g></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/carhire/car-hire.jpg",
          "alt": "Car hire"
        }
      },
      "transfers": {
        "canSellFlag": "TransferBookings",
        "productClass": "transfers",
        "product": "transfers",
        "text": "Airport <br class='hidden-xs'>Transfers",
        "productText": "Pre-book your airport transfer to resort - FREE cancellation included",
        "link": "/airport-transfers.html",
        "svg": "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128' class='svgfill'><g><path d='M35.87,119.08a12,12,0,1,1,12-13.36h0A12,12,0,0,1,37.25,119,12.33,12.33,0,0,1,35.87,119.08Zm0-20a8.07,8.07,0,0,0-.92.05,8,8,0,1,0,.92-.05Z'/><path d='M105.79,111.15a12,12,0,1,1,1.38-.08A12.35,12.35,0,0,1,105.79,111.15Zm0-20a8,8,0,0,0-8,8.91,8,8,0,0,0,15.91-1.8h0a8,8,0,0,0-7.94-7.11Z'/><path d='M45.71,107.14a2,2,0,0,1-.22-4l50.07-5.68a2,2,0,0,1,.45,4l-50.07,5.68Z'/><path d='M116.14,99.15a2,2,0,0,1-.22-4l6.37-.72a1.54,1.54,0,0,0,1.36-1.71l-3.28-28.94a2,2,0,0,1,4-.45l3.28,28.94a5.55,5.55,0,0,1-4.88,6.13l-6.37.72Z'/><path d='M29.39,75.09a2,2,0,0,1-2-1.77l-2.95-26a2,2,0,0,1,4-.45l2.95,26a2,2,0,0,1-1.76,2.21Z'/><path d='M52.18,72.51a2,2,0,0,1-2-1.77l-2.72-24a2,2,0,0,1,4-.45l2.72,24a2,2,0,0,1-1.76,2.21Z'/><path d='M97.07,67.42a2,2,0,0,1-2-1.77L92.27,40.78a2,2,0,1,1,4-.45l2.82,24.86A2,2,0,0,1,97.3,67.4Z'/><path d='M8.8,98.08a2,2,0,0,1-.22-4l3.73-.42-.38-3.33-3.73.42a2,2,0,1,1-.45-4l5.72-.65a2,2,0,0,1,2.21,1.76l.83,7.3a2,2,0,0,1-1.76,2.21L9,98.07Z'/><path d='M118.1,85.69a2,2,0,0,1-2-1.77l-.83-7.3a2,2,0,0,1,1.76-2.21l5.72-.65a2,2,0,1,1,.45,4l-3.73.42.38,3.33,3.73-.42a2,2,0,1,1,.45,4l-5.71.65Z'/><path d='M106.13,101a2,2,0,0,1-1.41-.59,1.43,1.43,0,0,1-.25-.3,1.7,1.7,0,0,1-.19-.35,1.5,1.5,0,0,1-.11-.37,1.72,1.72,0,0,1,0-.39,1.65,1.65,0,0,1,0-.39,2.33,2.33,0,0,1,.11-.38,1.81,1.81,0,0,1,.19-.34,1.49,1.49,0,0,1,.25-.31,2,2,0,0,1,1.8-.55,2.84,2.84,0,0,1,.38.12,2.18,2.18,0,0,1,.34.18,2.54,2.54,0,0,1,.3.25,1.49,1.49,0,0,1,.25.31,1.87,1.87,0,0,1,.19.34,2.19,2.19,0,0,1,.15.77,1.72,1.72,0,0,1,0,.39,1.55,1.55,0,0,1-.11.37,2.28,2.28,0,0,1-.18.35,2.44,2.44,0,0,1-.56.55,1.58,1.58,0,0,1-.34.18,2.23,2.23,0,0,1-.38.12A2.51,2.51,0,0,1,106.13,101Z'/><path d='M36.38,108.92a2,2,0,0,1-2-2,1.72,1.72,0,0,1,0-.39,1.57,1.57,0,0,1,.11-.37,2.29,2.29,0,0,1,.18-.35,2.5,2.5,0,0,1,.25-.3,1.89,1.89,0,0,1,.31-.25,2.15,2.15,0,0,1,.34-.18A2.36,2.36,0,0,1,36,105a2,2,0,0,1,1.8.55,1.85,1.85,0,0,1,.25.3,2.33,2.33,0,0,1,.18.35,2.2,2.2,0,0,1,.12.37,2,2,0,0,1,0,.79,2.59,2.59,0,0,1-.11.37A2.27,2.27,0,0,1,38,108a2.42,2.42,0,0,1-.25.31A2,2,0,0,1,36.38,108.92Z'/><path d='M83.49,50.94c-5.24,0-12.24-1.63-12.95-7.86l-1.81-16a2.08,2.08,0,0,1,0-.32,4.71,4.71,0,0,0-1.61-3.28c-2.11-1.92-6.1-2.6-11.54-2L10.28,26.65a6.58,6.58,0,0,0,1.85,3.16,3.45,3.45,0,0,0,2.7.69L39,27.76l.45,4L15.28,34.48a7.46,7.46,0,0,1-5.7-1.58c-3.17-2.61-3.64-7.3-3.68-7.82a2,2,0,0,1,1.77-2.15l47.45-5.38c6.79-.77,11.77.27,14.79,3.1a8.64,8.64,0,0,1,2.81,6.14l1.8,15.84c.57,5,10.66,4.25,10.77,4.24a2,2,0,1,1,.36,4C85,50.9,84.26,50.94,83.49,50.94Z'/><path d='M22.43,42.16c-2.5,0-7.4-1.65-8.16-7.93a2,2,0,1,1,4-.48c.49,4,3.53,4.38,4.11,4.41l23.8-2.81a2,2,0,1,1,.47,4L22.68,42.15Z'/><path d='M31.55,50.08c-2.73,0-7.26-1.75-8.19-8.6a2,2,0,1,1,4-.54c.67,5,3.61,5.16,4.29,5.14l30-3.84a2,2,0,1,1,.51,4L32,50.06Z'/><path d='M72.89,17.15a2,2,0,0,1-1.63-.84c-.14-.19-3-4-9.11-3.29a2,2,0,1,1-.48-4c8.57-1,12.69,4.71,12.87,5a2,2,0,0,1-1.64,3.14Z'/><path d='M25.37,106.41h-.18l-12-1.1-.31-.05c-4.31-1.09-6.85-4.8-7.56-11L.45,51.51a2,2,0,0,1,.25-1.22C.9,50,2.63,47.08,5.5,46.75l19.62-2.2a2,2,0,1,1,.45,4L5.95,50.73A2.79,2.79,0,0,0,4.51,51.8L9.27,93.75c.66,5.8,2.8,7.13,4.42,7.58l11.87,1.08a2,2,0,0,1-.18,4Z'/><path d='M6.37,78.75a2,2,0,0,1-.22-4L119.39,61.9,109.16,41.51c-.82-1-2-2.16-3.37-2L72.53,43.25a2,2,0,0,1-.45-4l33.25-3.74c1.8-.21,4.49.27,7.11,3.69a2,2,0,0,1,.2.32l11.6,23.12a2,2,0,0,1-1.56,2.88L6.6,78.73Z'/></g></svg>",
        "switchImage": {
          "src": "https://image-cloud.dock-yard.io/image/holidayextras.co.uk/engine-images/transfers/airport-transfers.jpg",
          "alt": "Airport transfers"
        }
      }
    },
    "parkingLabels": {
      "cp": {
        "locationLabel": "Flying from"
      },
      "portcp": {
        "locationLabel": "Travelling from"
      }
    },
    "hotelLabels": {
      "ho": {
        "startDate": "Hotel check-in",
        "endDate": "Return date",
        "startDateHomepageTest": "Check in (1 night)",
        "endDateHomepageTest": "Collect car"
      },
      "portho": {
        "locationLabel": "Travelling from",
        "includeAirportParkingLabel": "Include port parking",
        "startDate": "Hotel check-in",
        "endDate": "Return date",
        "startDateHomepageTest": "Check in (1 night)",
        "endDateHomepageTest": "Collect car"
      },
      "porthcp": {
        "locationLabel": "Travelling from",
        "ppts": {
          "startDate": "Parking from",
          "endDate": "Hotel check-in",
          "startDateHomepageTest": "Parking from",
          "endDateHomepageTest": "Hotel check in"
        },
        "nonPpts": {
          "startDate": "Hotel and Parking check-in",
          "endDate": "Collect car on",
          "startDateHomepageTest": "Hotel check in",
          "endDateHomepageTest": "Collect car"
        }
      },
      "hcp": {
        "ppts": {
          "startDate": "Parking from",
          "endDate": "Hotel check-in",
          "startDateHomepageTest": "Parking from",
          "endDateHomepageTest": "Hotel check in"
        },
        "nonPpts": {
          "startDate": "Hotel and Parking check-in",
          "endDate": "Collect car on",
          "startDateHomepageTest": "Hotel check in",
          "endDateHomepageTest": "Collect car"
        }
      }
    }
  },
  "brand": {
    "version": "4.2.1"
  },
  "sliderSettings": {
    "dots": false,
    "infinite": true,
    "speed": 500,
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "autoplay": true,
    "autoplaySpeed": 5000,
    "pauseOnHover": true
  },
  "carouselSettings": {
    "cropPath": "https://secure.holidayextras.co.uk/img/q/233/158/100/0/convert/jpg/i/static1.holidayextras.com/",
    "path": "https://static1.holidayextras.com"
  },
  "routes": {
    "managemybooking": "https://v2.holidayextras.co.uk/manage-booking/view/"
  }
};module.exports = config;